// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"816":"83d0ee41","832":"678a13ed"}[chunkId] + ".chunk.css";
};